import React, { useMemo } from 'react';
// @ts-ignore
import ImageUploadBtnGp from '@gp/components/ImageUploadBtnGp';
import {
  Input,
  Justify,
  Row,
  Button,
  Dropdown,
  notification,
  Form,
  Radio,
  Col,
  FormItem,
} from 'tea-component';
import AutoTextareaNew from '@gp/components/AutoTextareaNew';
import classnames from 'classnames';
import './index.scss';

export default function ElevatorPitchImageUpload(props: any) {
  const {
    // 提交
    isJustConfirm,
    onChangeImg,
    valueParams,
    setValueParams,
  } = props;

  const handleImageUploaderChange = (e: any) => {
    onChangeImg({
      path: e.path,
      cover: e.cover,
    });
  };
  const deleteOutsideChange = () => {
    setValueParams({
      ...valueParams,
      cloudPath: '',
      cover: '',
    });
  };

  const statusCur: any = useMemo(() => {
    // if (isJustConfirm) {
    //   if (!valueParams?.introduction) {
    //     return 'error';
    //   }
    // }
    return '';
  }, [isJustConfirm, valueParams]);

  const messageCur = useMemo(() => {
    // if (isJustConfirm) {
    //   if (statusCur === 'error') {
    //     return 'Please check that all inputs are complete. ';
    //   }
    // }
    return '';
  }, [statusCur, isJustConfirm]);

  return (
    <div className="dbg-elevator-pitch-modal-image-upload">
      <div className="dbg-elevator-pitch-modal-image-upload-top">
        <Form
          className={classnames({
            'is-error': statusCur === 'error',
          })}
          layout="fixed"
        >
          <FormItem
            status={statusCur}
            message={''}
            className={classnames('dbg-elevator-pitch-modal-image-upload-img', {
              'is-empty': !valueParams?.cloudPath,
            })}
          >
            <ImageUploadBtnGp
              multiple={false}
              onUploadSuccess={handleImageUploaderChange}
              deleteOutside={deleteOutsideChange}
              className={'dbg-elevator-pitch-modal-image-upload-btn'}
              editImagesData={valueParams}
            />
          </FormItem>

          <FormItem
            status={statusCur}
            message={messageCur}
            className={classnames('dbg-elevator-pitch-modal-image-upload-desc', {
              'is-empty': !valueParams?.introduction,
            })}
          >
            <div className="dbg-elevator-pitch-modal-image-upload-bottom">
              <div className="dbg-elevator-pitch-modal-image-upload-bottom-area">
                <AutoTextareaNew
                  key={'elevator-pitch-modal-auto-area'}
                  className="dbg-dps-report-update-input-item dbg-auto-text-area-indented-textarea"
                  placeholder={'Please input Elevator Pitch Introduction'}
                  minHeight={160}
                  // maxLength={300}
                  disabled={false}
                  showCount={false}
                  showPrefixText={true}
                  isDisabledEnter={false}
                  prefixText={'Introduction'}
                  value={valueParams?.introduction}
                  onChange={(value: any) => {
                    setValueParams({
                      ...valueParams,
                      introduction: value,
                    });
                  }}
                />
              </div>
            </div>
          </FormItem>
        </Form>
      </div>
    </div>
  );
}
